//eslint-disable-next-line
export const PASS_PATTERN = /^(?=.*[A-Za-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/g;
